export var TimePickerStringsForDocs = function () {
    return {
        /** String to display in the placeholder */
        'timePicker.ariaLabel': 'Choose a time',
        /** String to display in the hour group */
        'timePicker.hours.groupLabel': 'Hour',
        /** String to display in the minute group */
        'timePicker.minutes.groupLabel': 'Minute',
        /** String to display in the am/pm group */
        'timePicker.periods.groupLabel': 'AM/PM',
        /** String to display in the second group */
        'timePicker.seconds.groupLabel': 'Second',
        /** String to use as the aria-label for the time picker hour segment's scroll up button */
        'timePicker.hours.scrollUpBtnLabel': 'Scroll hours up',
        /** String to use as the aria-label for the time picker hour segment's scroll down button */
        'timePicker.hours.scrollDownBtnLabel': 'Scroll hours down',
        /** String to use as the aria-label for the time picker minute segment's scroll up button */
        'timePicker.minutes.scrollUpBtnLabel': 'Scroll minutes up',
        /** String to use as the aria-label for the time picker minute segment's scroll down button */
        'timePicker.minutes.scrollDownBtnLabel': 'MinuteScroll minutes down',
        /** String to use as the aria-label for the time picker period segment's scroll up button */
        'timePicker.periods.scrollUpBtnLabel': 'Scroll AM / PM up',
        /** String to use as the aria-label for the time picker period segment's scroll down button */
        'timePicker.periods.scrollDownBtnLabel': 'Scroll AM / PM down',
        /** String to use as the aria-label for the time picker second segment's scroll up button */
        'timePicker.seconds.scrollUpBtnLabel': 'Scroll seconds up',
        /** String to use as the aria-label for the time picker second segment's scroll down button */
        'timePicker.seconds.scrollDownBtnLabel': 'Scroll seconds down',
    };
};
export var TimePickerStrings = TimePickerStringsForDocs();
